/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import PlatformNav from "./nav/PlatformNav";
import { ProductItem, getSignInProducts, launchUrl } from "../data/productsData";
import { loadProducts } from "../services/productSource";

const Header = () => {
  const bodyRef = useRef<HTMLBodyElement | null>(null);
  const [signInProducts, setSignInProducts] = useState<ProductItem[]>(() => getSignInProducts());

  useEffect(() => {
    bodyRef.current = document.querySelector("body");
    let cancelled = false;
    loadProducts().then((products) => {
      if (!cancelled) {
        setSignInProducts(products.filter((p) => p.hasSignIn && launchUrl(p)));
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const showCanvas3 = () => {
    if (bodyRef.current) {
      bodyRef.current.style.overflow = "hidden";
    }

    const canvas3 = gsap.timeline();

    canvas3.to(".offcanvas-3__area", {
      left: 0,
      visibility: "visible",
      duration: 0.8,
      opacity: 1,
      rotationY: 0,
      perspective: 0,
    });

    canvas3.to(
      ".offcanvas-3__menu ul li",
      {
        opacity: 1,
        top: 0,
        stagger: 0.05,
        duration: 1,
        rotationX: 0,
      },
      "-=0.1"
    );

    canvas3.to(
      ".offcanvas-3__meta",
      {
        top: 0,
        visibility: "visible",
        duration: 0.8,
        opacity: 1,
      },
      "-=0.5"
    );

    canvas3.to(
      ".offcanvas-3__social",
      {
        top: 0,
        visibility: "visible",
        duration: 0.8,
        opacity: 1,
      },
      "-=0.5"
    );
  };

  const hideCanvas3 = () => {
    if (bodyRef.current) {
      bodyRef.current.style.overflow = "auto";
    }

    const canvas3 = gsap.timeline();

    canvas3.to(".offcanvas-3__area", {
      duration: 0.8,
      rotationY: -90,
      opacity: 0,
    });

    canvas3.to(".offcanvas-3__area", {
      visibility: "hidden",
      duration: 0.1,
      rotationY: 50,
      left: 0,
      rotationX: 0,
    });

    canvas3.to(".offcanvas-3__menu ul li", {
      opacity: 0,
      top: -100,
      stagger: 0.01,
      duration: 0.1,
      rotationX: 50,
    });

    canvas3.to(
      ".offcanvas-3__meta",
      {
        top: -30,
        visibility: "hidden",
        duration: 0.8,
        opacity: 1,
      },
      "-=0.5"
    );

    canvas3.to(
      ".offcanvas-3__social",
      {
        top: -30,
        visibility: "hidden",
        duration: 0.8,
        opacity: 1,
      },
      "-=0.5"
    );
  };

  return (
    <>
      <>
        <div className="offcanvas-3__area">
          <div className="offcanvas-3__inner">
            <div className="offcanvas-3__meta-wrapper">
              <div>
                <button
                  id="close_offcanvas"
                  className="close-button close-offcanvas"
                  onClick={hideCanvas3}
                >
                  <span></span>
                  <span></span>
                </button>
              </div>
              <div>
                <div className="offcanvas-3__meta mb-145 d-none d-md-block">
                  <ul>
                    <li>
                      <a href="tel:+91-9429167971" className="unnerline">
                        <u>+91-9429167971</u>
                      </a>
                    </li>
                    <li>
                      <a href="mailto:hello@mindsyncx.com">
                        hello@mindsyncx.com
                      </a>
                    </li>
                    <li>
                      <a href="/">
                        A/1109, Money Plant High Street, <br />
                        Jagatpur Road, Near S.G. Highway, <br />
                        Ahmedabad - 382470. INDIA
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="offcanvas-3__social d-none d-md-block">
                  <p className="title">Follow Me</p>
                  <div className="offcanvas-3__social-links">
                    <a href="https://www.facebook.com/profile.php?id=61577047823875&sk=about">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                    <a href="https://x.com/mindsyncx">
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                    <a href="https://www.linkedin.com/company/mindsyncxlabs">
                      <i className="fa-brands fa-dribbble"></i>
                    </a>
                    <a href="https://www.instagram.com/mindsyncx_labs/">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="offcanvas-3__menu-wrapper">
              <nav className="nav-menu offcanvas-3__menu">
                <div className="offcanvas-3__mobile-cta d-md-none" style={{ marginBottom: 24 }}>
                  <a
                    href="/contact"
                    className="wc-btn wc-btn-primary"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      padding: "14px 20px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      backgroundColor: "var(--mx-brand-blue)",
                      color: "#ffffff"
                    }}
                  >
                    Get in touch
                  </a>
                </div>
                <ul>
                  {[
                    { label: "Home", href: "/" },
                    { label: "Why MindSyncX", href: "/about" },
                    { label: "Services", href: "/services" },
                    { label: "Products", href: "/products" },
                    // { label: "Career", href: "/career" },
                    { label: "Case Studies", href: "/case-studies" },
                    { label: "Security", href: "/security" },
                    { label: "Faq", href: "/faqs" },
                    { label: "Blogs", href: "/blogs" },
                    { label: "Contact", href: "/contact" },
                  ].map((item, index) => (
                    <li key={index}>
                      <a href={item.href}>{item.label}</a>
                    </li>
                  ))}
                </ul>
                {/* The Sign in mega-menu is desktop-only, so the apps need a way
                    in on mobile too — otherwise "Launch app" simply does not
                    exist for a phone visitor. */}
                {signInProducts.length > 0 && (
                  <>
                    <p className="mx-eyebrow" style={{ marginTop: 28 }}>Open an app</p>
                    <ul>
                      {signInProducts.map((p) => (
                        <li key={p.slug}>
                          <a
                            href={launchUrl(p) || p.subdomain}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Sign in to ${p.name} in a new tab`}
                          >
                            {p.name} ↗
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </nav>
            </div>
          </div>
        </div>
      </>
      {/* Header area start */}
      <header
        className={
          !window.location.pathname.includes("Career")
            ? "header-area"
            : "header-area-career"
        }
      >
        <div className="container mx-container">
          <div className="header-area__inner">
            <div className="header__logo">
              <a href="/" aria-label="Home">
                {!window.location.pathname.includes("Career") ? (
                  <img
                    className={"show-light"}
                    src="/assets/imgs/logo/logo.svg"
                    alt="Site Logo"
                  />
                ) : null}
                <img
                  className={
                    window.location.pathname.includes("Career")
                      ? ""
                      : "show-dark"
                  }
                  src="/assets/imgs/logo/logo-light.svg"
                  alt="Site Logo"
                />
              </a>
            </div>
            <div className="header__nav pos-center">
              <nav
                className={
                  window.location.pathname.includes("Career")
                    ? "main-menu menu-light"
                    : "main-menu"
                }
              >
                <ul>
                  <li>
                    <a href="/about">Why MindSyncX</a>
                  </li>
                  {/* Platform, Solutions and Sign in render from the product
                      registry. Below the header breakpoint they hide themselves
                      and the existing offcanvas menu takes over. */}
                  <PlatformNav />
                  <li>
                    <a href="/services">Services</a>
                  </li>
                  <li className="menu-item-has-children">
                    <a href="#">Resources</a>
                    <ul className="dp-menu">
                      <li>
                        <a href="/case-studies">Case Studies</a>
                      </li>
                      <li>
                        <a href="/security">Security</a>
                      </li>
                      <li>
                        <a href="/blogs">Blogs</a>
                      </li>
                      <li>
                        <a href="/faqs">FAQ</a>
                      </li>
                    </ul>
                  </li>
                  {/* <li>
                    <a href="/career">Career</a>
                  </li> */}
                  {/* <li>
                    <a href="/contact">Contact</a>
                  </li> */}
                </ul>
              </nav>
            </div>
            <div className="header__button d-none d-md-block">
              <a
                href="/contact"
                className="wc-btn wc-btn-primary btn-text-flip"
              >
                {" "}
                <span data-text="Get in touch">Get in touch</span>
              </a>
            </div>
            <div className="header__navicon d-xl-none">
              <button
                onClick={showCanvas3}
                className="open-offcanvas"
                aria-label="Open navigation menu"
              >
                <i className="fa-solid fa-bars" />
              </button>
            </div>
          </div>
        </div>
      </header>
      {/* Header area end */}
    </>
  );
};

export default Header;
